import React from "react";
import {SelectColumnsConfiguration} from "./configuration/select-columns-configuration";
import {PreviewTab} from "../preview-tab/preview-tab";

export const SelectColumnsStepPanelTabs = {
    configuration: SelectColumnsConfiguration,
    preview: PreviewTab,
};
